import React from 'react';

import Button from '../../../components/ui/Button';

const LineHeader = ({ lineData, onClose, onNavigate }) => {
  const formattedGid = lineData?.gid ? String(lineData?.gid)?.padStart(4, '0') : null;

  const locationLabel = (() => {
    if (formattedGid && lineData?.act && lineData?.scene) {
      const parts = [`#${formattedGid}`, `Act ${lineData?.act}`, `Scene ${lineData?.scene}`];
      if (lineData?.lineInScene) parts?.push(`Line ${lineData?.lineInScene}`);
      return parts?.join(' · ');
    }
    if (formattedGid) return `#${formattedGid}`;
    return lineData?.lineId || '';
  })();

  return (
    <div className="flex items-center justify-between p-6 border-b border-border bg-card">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          iconName="X"
          iconSize={20}
        >
          <span className="sr-only">Close modal</span>
        </Button>
        <div>
          <h2 className="text-xl font-semibold text-foreground">Edit Line</h2>
          <p className="text-sm text-muted-foreground mt-1">
            {lineData?.playTitle} • {locationLabel}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onNavigate('prev')}
          disabled={!lineData?.hasPrevious}
          iconName="ChevronLeft"
          iconPosition="left"
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onNavigate('next')}
          disabled={!lineData?.hasNext}
          iconName="ChevronRight"
          iconPosition="right"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default LineHeader;